import request from '@/CommonDP/utils/request';
// revit 样板维护
export default {
  // revit版本下拉框
  getRevitVersionDropDownBox(params) {
    return request
      .get(`/revitSystemModelMaintenance/revitVersionDropDownBox`, {
        params
      })
      .then((res) => res);
  },
  // 文件列表
  getrevitSystemModelMaintenanceList(params) {
    return request
      .get(`/revitSystemModelMaintenance/selectFile`, { params })
      .then((res) => res);
  },
  // 下载
  downloadDepartmentNameFile(fileID) {
    return request({
      url: `/revitSystemModelMaintenance/downloadDepartmentNameFile/download/${fileID}`,
      method: 'get',
      responseType: 'blob'
    });
  },
  // 删除
  deleteRevitFile(params) {
    return request.get('/revitSystemModelMaintenance/deleteRevitFile', {
      params
    });
  },
  // 上传
  uploadDepartmentNameFile(params) {
    return request
      .post(
        `/revitSystemModelMaintenance/uploadDepartmentNameFile`,
        params
      )
      .then((res) => res);
  },
  // 修改
  updateRevitFile(params) {
    return request
      .post(`/revitSystemModelMaintenance/updateRevitFile`, params)
      .then((res) => res);
  }
};
